if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', (e) => {
            // if (this.dataset.zoom === 'lightbox') {
            //   const index = Array.from(mediaToSwitch.parentNode.children).indexOf(mediaToSwitch);
            //   this.lightbox.openPosition(index);
            // }

            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          });
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      connectedCallback() {
        if (this.dataset.zoom === 'lightbox') {
          this.initLightbox();
        }
      }

      initLightbox() {
        const closeText = document.querySelector(`#${this.id}-CloseText`)?.innerHTML;
        const nextText = document.querySelector(`#${this.id}-NavNextText`)?.innerHTML;
        const prevText = document.querySelector(`#${this.id}-NavPrevText`)?.innerHTML;

        this.lightbox = new SimpleLightbox(`#${this.id} [data-lightbox-media]`, {
          closeText: closeText || '&times;',
          navText: [prevText || '←', nextText || '→'],
          overlayOpacity: 0.9,
          className: 'product-page-simple-lightbox',
          sourceAttr: 'data-lightbox-media',
          captions: false,
          animationSpeed: 200,
          history: false,
        });

        // Tiny lightbox doesnt support videos out of the box, so we need to handle it ourselves
        const videoLightboxProccessor = (itemEl) => {
          const lightboxImageWrap = document.querySelector('.sl-wrapper .sl-image');
          const lightboxImage = lightboxImageWrap.querySelector('img');

          // Remove image display none if any
          lightboxImage.classList.remove('hidden');

          // Remove any existing deferred media
          const existingDeferredMedia = lightboxImageWrap.querySelector('.deferred-media');
          if (existingDeferredMedia) {
            existingDeferredMedia.remove();
          }

          // Check if we have defered media next to the clicked image
          const deferredMedia = itemEl.querySelector('.deferred-media');
          if (deferredMedia) {
            const clonedDeferredMedia = deferredMedia.cloneNode(true);
            clonedDeferredMedia.style.opacity = '1';

            if (lightboxImageWrap) {
              // hide the image
              lightboxImage.classList.add('hidden');

              // Append the video element
              lightboxImageWrap.appendChild(clonedDeferredMedia);

              // Load the video content
              this.playActiveMedia(lightboxImageWrap);
            }
          }
        };

        this.lightbox.on('changed.simplelightbox', (e) => {
          const target = e.currentTarget || e.target;
          videoLightboxProccessor(target);
          this.setActiveMedia(target.dataset.mediaId, false);
        });

        this.lightbox.on('shown.simplelightbox', (e) => {
          videoLightboxProccessor(e.currentTarget || e.target);
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        if (this.dataset.zoom !== 'lightbox') {
          this.playActiveMedia(activeMedia);
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}
